module.exports = __webpack_public_path__ + "img/tool.af16496d.svg";